export const EMPTY_OBJECT = {};
